import React from 'react';
import jQuery from 'jquery';
import Configurator from './Configurator.jsx';
import Button from "./ui/button/Button.jsx";
import Image from './ui/features/Image.jsx';
import styles from './LanConfigurator.styl';
import Table from "./ui/features/Table.jsx";



const CATEGORY_NAME 				= 'Категория_Name'
const SCREEN_PRES		 				= 'Экран поверх элемента скрутки_Name'
const ADD_SCREEN_PRES				= 'Экранированный_Code'
const OUTER_SHELL_COLOR 		= 'Цвет внешн оболочки_Name'
const OUTER_SHELL_MATERIAL 	= 'Материал внешн оболочки_Name'
const INNER_MATERIAL 				= 'Материал внутр проводника_Name'
const CABLE_BRAND 					= 'Материал внешн оболочки_Name'
const CONNECTOR_TYPE 				= 'Тип соединителя или разъема_Name'
const IDC_TYPE 							= 'Тип заделки контактов модулей IDC_Name'
const FREQUENCY 						= 'Рабочая частота МГц'
const PORT_NUMB 						= 'Подходит для количества коннекторов'
const MOUNT_TYPE						= 'Тип монтажа_Name'
const BANDWIDTH							= 'Полоса пропускания МГц'
const ORGANIZER							= 'Кабельный органайзер_Code'
const LENGTH								= 'Длина м'
const CONN_TYPE							= 'Тип коннектора подключения 1_Name'
const EXT_DIAM							= 'Внешний диаметр кабеля мм'
const INT_DIAM							= 'Диаметр жилы - кабеля мм'
const EXT_COLOR							= 'Цвет внешн оболочки_Name'
const AWG_TYPE							= 'Классификация по AWG'
const CABLE_DIAM						= 'Диаметр подключаемых проводников мм'
const COMPABILITY						= 'Совместимость'
const AWG_DIAM							= 'Диаметр обжимаемого кабеля по AWG'
const COVER_TYPE						= 'Тип оболочки_Name'
const CABLE_TYPE						= 'Тип кабеля_Name'

const RATCHET								= 'Храповый механизм_Code'
const IMPACT								= 'Ударный механизм_Code'
const COMPRESS_F						= 'Подходит для компресс разъемов типа F_Code'
const PLUG_F								= 'Подходит для разъема типа F_Code'
const LSA_PLUS							= 'Подходит для плинта LSA-plus_Code'
const LJ_PLUS								= 'Подходит для разъема типа RJ_Code'
const FIX										= 'С фиксирующим устройством_Code'
const CUT										= 'С отрезным устройством_Code'
const CLEAN									= 'С функцией зачистки кабеля_Code'
const CUT_DEEP							= 'Регулируемая глубина надреза_Code'


const initialLanState = {
	//Марка
	filterBrand: 'Выбрать', 						// Выбранное значение марки
	//Тип экрана
	filterShieldType: 'Выбрать', 				// Выбранное значение типа экрана
	//Наличие экрана
	filterShieldAvail: 'Выбрать', 			// Выбранное значение наличия экрана
	//Материал оболочки
	filterShell: 'Выбрать', 						// Выбранное значение материала оболочки
	//Цвет оболочки
	filterShellColor: 'Выбрать', 				// Выбранное значение цвета оболочки
	//Категория
	filterCategory: 'Выбрать', 					// Выбранное значение категории
}

const initialKoaksState = {
	//Материал внутри проводника
	filterKoaksInternMat: 'Выбрать', 						// Выбранное значение материала внутри проводника
	//Материал провода
	filterKoaksCableBrand: 'Выбрать', 						// Выбранное значение материала проводника
}

const initialAddState ={

	//Тип коннектора
	filterConnectorType: 'Выбрать', 		// Выбранное значение типа коннектора
	//Количество портов
	filterPorts: 'Выбрать', 						// Выбранное значение количества портов
	//Рабочая частота
	filterFrequency: 'Выбрать', 				// Выбранное значение рабочей частоты
	//Тип заделки
	filterTerminationType: 'Выбрать', 	// Выбранное значение типов заделки
	//Тип монтажа
	filterMountingType: 'Выбрать', 			// Выбранное значение типов

	//Количество портов для патч-панелей
	filterPatchPorts: 'Выбрать', 			// Выбранное значение Количества портов для патч-панелей
	//Тип соединеия для патч-панелей
	filterPatchConnectionType: 'Выбрать', 			// Выбранное значение Типа соединеия для патч-панелей
	//Тип заделки для патч-панелей
	filterPatchTerminationType: 'Выбрать', 			// Выбранное значение Типа заделки для патч-панелей
	//Каблеьный органайзер для патч-панелей
	filterCableOrg: 'Выбрать', 								  // Выбранное значение Каблеьный органайзер для патч-панелей
	//Тип монтажа
	filterPatchMountType: 'Выбрать', 						// Выбранное значение Тип монтажа для патч-панелей
	//Пропускная способность
	filterBandwidth: 'Выбрать', 								// Выбранное значение пропуской способности для патч-панелей

	//Длинна
	filterPatchCordLength: 'Выбрать', 					// Выбранное значение длинны для патч-корда
	//Цвет внешней оболочки
	filterPatchCordColor: 'Выбрать', 						// Выбранное значение Цвета внешней оболочки для патч-корда
	//Тип коннектора оболочки
	filterPatchCordConnectorType: 'Выбрать', 		// Выбранное значение Типа коннектора оболочки для патч-корда
	//Диаметр внешней оболовчки
	filterPatchCordExternal: 'Выбрать', 				// Выбранное значение диаметра внешней оболочки для патч-корда
	//Диаметр жилы
	filterPatchCordInternal: 'Выбрать', 				// Выбранное значение диаметра жилы для патч-корда
	//Количество информационных портов модульной вставки
	filterInsertNum: 'Выбрать', 								// Выбранное значение количества информационных портов для модульной вставки




	//Тип разъема
	filterPlugType: 'Выбрать',									// Выбранное значение типа разъема
	//Классификация по AWG
	filterAwg: 'Выбрать',												// Выбранное значение классификации по AWG
	//Диаметр подключаемых проводников
	filterPlugDiam: 'Выбрать',									// Выбранное значение диаметра подключаемых проводников
	//Совместимость инструментов
	filterCompatibility: 'Выбрать',							// Выбранное значение совместимости
	//Диаметр обжимаемого кабеля по AWG
	filterDiamAWG: 'Выбрать',										// Выбранное значение Диаметра

	// Выбор инструмента
	// Храповый механизм
	ratchet:false,
	// Ударный механизм
	percussion: false,
	// Подходит для компресс разъема типа f
	compressF: false,
	// Подходит для разъема типа f
	connectorF: false,
	// Подходит для разъема типа lsa
	lsa: false,
	// Подходит для разъема типа RJ
	RJ: false,
	// С фиксирующим устройством
	fixTool: false,
	// С отрезным устройством
	cutTool: false,
	// С функцией зачистки кабеля
	clear: false,
	// Регулируемая глубина надреза
	deep: false,

}

class LanConfigurator extends Configurator {

	componentDidMount() {

		const groupIdArr = ['20.02', '20.03']
		const idPromise = groupIdArr.map(this.getItemList)
		const allProgucts = Promise.all(idPromise)


		allProgucts.then(res => {
			let result = [...res[0], ...res[1]]

			const newArr = result.reduce((counter, item) =>{
				if(item.name.includes("ITK Инструмент") || item.name.includes("Инструмент")) counter.toolList.push({...item, article:item.Code})
				if((item.name.includes("ITK Витая пара")
					|| item.name.includes("ITK Каб.")
					) && item.TM === 'ITK') counter.lanList.push({...item, article:item.Code})
				if(item.name.includes("Кабель коаксиальный")) counter.koaksList.push({...item, article:item.Code})
				if(item.name.includes("ITK Разъём") && item.TM === 'ITK') counter.plugList.push({...item, article:item.Code})
				if((item.Code[0] + item.Code[1])  === 'PP' && item.TM === 'ITK') counter.patchPanelList.push({...item, article:item.Code})
				if((item.Code[0] + item.Code[1])  === 'PC'  && item.TM === 'ITK') counter.patchCordList.push({...item, article:item.Code})
				if((item.name.includes("ITK Вставка") && item.TM === 'ITK')) counter.modulInsertList.push({...item, article:item.Code})
				if((item.name.includes("ITK Лицевая рамка") && item.TM === 'ITK')) counter.modulInserFrameList.push({...item, article:item.Code})
				if((item.name.includes("Адаптер") || (item.name.includes("адаптер"))) && item.TM === 'ITK') counter.adapterList.push({...item, article:item.Code})
				if((item.name.includes("ITK Модуль Keystone Jack") || (item.name.includes("модуль ")) ) && item.TM === 'ITK') counter.moduleList.push({...item, article:item.Code})
				if(item.name.includes("розетк") && item.name.includes("Корпус") && item.TM === 'ITK') counter.moduleFrameList.push({...item, article:item.Code})
				if(item.name.includes("розетк") && !item.name.includes("Корпус") && item.TM === 'ITK') counter.socketList.push({...item, article:item.Code})
				return counter
			},{
				toolList:[],
				lanList:[],
				koaksList:[],
				plugList:[],
				adapterList:[],
				moduleList:[],
				patchPanelList:[],
				patchCordList:[],
				modulInsertList:[],
				modulInserFrameList:[],
				moduleFrameList:[],
				socketList:[],
			})

			newArr.lanList = newArr.lanList.map(item=>({...item, screen_type:item.name.split(' ')[3]}))

			let lanDBList = [
				...newArr.lanList,
				...newArr.plugList,
				...newArr.adapterList,
				...newArr.moduleList,
				...newArr.patchPanelList,
				...newArr.patchCordList,
				...newArr.modulInsertList,
				...newArr.modulInserFrameList,
				...newArr.moduleFrameList,
				...newArr.socketList,
				...newArr.toolList]

			this.setState({
				itemList: lanDBList,
				lanList:newArr.lanList,
				koaksList:newArr.koaksList,
				plugList:newArr.plugList,
				adapterList:newArr.adapterList,
				moduleList:newArr.moduleList,
				patchPanelList:newArr.patchPanelList,
				patchCordList:newArr.patchCordList,
				modulInsertList:newArr.modulInsertList,
				modulInserFrameList: newArr.modulInserFrameList,
				moduleFrameList: newArr.moduleFrameList,
				socketList: newArr.socketList,
				toolList:newArr.toolList,
				lanDBList
			}, ()=>{
				this.changeLanFilterOptions(this.state.lanList)
			})


		})
	}

	//Конструктор
	constructor(props) {

		super(props);
		this.state = jQuery.extend({}, this.state,{
			//Списки
			itemList: [], // Подобранные аксессуары
			specList: [], // Спецификация оборудования
			lanList:[],
			koaksList:[],
			plugList:[],
			adapterList:[],
			moduleList:[],
			patchPanelList:[],
			patchCordList:[],
			modulInsertList:[],
			modulInserFrameList:[],
			toolList:[],
			lanDBList:[],
			summ:0,

			//Высота таблицы
			tableHeight: '390px',
			tableTop: '363px',

			//Разрешение на использование доп фильтров
			addFilterEnabled: false,
			//Тип Таба
			tabType:"Lan",

			//Дополнительные устройства
			filterAddDivice: 'Выбрать',					// Выбранное значение дополнительных материалов

			brandOptions: [], 									// Варианты выбора марки
			shieldTypeOptions: [], 							// Варианты выбора типа экрана
			shieldAvailOptions: [], 							// Варианты выбора наличия экрана
			shellOptions: [], 										// Варианты выбора материала оболочки
			shellColorOptions: [], 							// Варианты выбора цвета оболочки
			categoryOptions: [], 								// Варианты выбора категории
			koaksInternMatOptions: [], 									// Варианты выбора материала внутри проводника
			koaksCableBrandOptions: [], 									// Варианты выбора материала проводника
			connectorTypeOptions: [], 						// Варианты выбора типов коннектора
			portsOptions: [], 										// Варианты выбора количества портов
			frequencyOptions: [], 								// Варианты выбора рабочей частоты
			terminationTypeOptions: [], 					// Варианты выбора типов заделки
			mountingTypeOptions: [], 						// Варианты выбора типов монтажа
			patchPortsOptions: [], 						// Варианты выбора Количества портов для патч-панелей
			patchConnectionTypeOptions: [], 						// Варианты выбора Типа соединеия для патч-панелей
			patchTerminationTypeOptions: [], 						// Варианты выбора Типа заделки для патч-панелей
			cableOrgOptions: [], 									// Варианты выбора Каблеьный органайзер для патч-панелей
			patchMountTypeOptions: [], 									// Варианты выбора Тип монтажа для патч-панелей
			bandwidthOptions: [], 											// Варианты выбора пропуской способности для патч-панелей
			patchCordLengthOptions: [], 								// Варианты выбора длинны для патч-корда
			patchCordColorOptions: [], 									// Варианты выбора Цвета внешней оболочки для патч-корда
			patchCordConnectorTypeOptions: [], 					// Варианты выбора Типа коннектора оболочки для патч-корда
			patchCordExternalOptions: [], 							// Варианты выбора диаметра внешней оболочки для патч-корда
			patchCordInternalOptions: [], 							// Варианты выбора диаметра жилы для патч-корда
			insertNumOptions: [], 											// Варианты выбора количества информационных портов для модульной вставки
			addDiviceOptions:[],												// Варианты выбора дополнительных материалов
			plugTypeOptions:[],													// Варианты выбора типа разъема
			awgOptions:[],															// Варианты выбора классификации по AWG
			plugDiamOptions:[],													// Варианты выбора диаметра подключаемых проводников
			compatibilityOptions:[],										// Варианты выбора совместимости
			diamAWGOptions:[],													// Варианты выбора Диаметра

			...initialAddState,
			...initialLanState,
			...initialKoaksState
		});

		this.mainDropDown 											= this.mainDropDown.bind(this)
		this.moduleDropDown 										= this.moduleDropDown.bind(this)
		this.patchPanelDropDown 								= this.patchPanelDropDown.bind(this)
		this.patchCordDropDown 									= this.patchCordDropDown.bind(this)
		this.koaksCableDropDown 								= this.koaksCableDropDown.bind(this)
		this.plugDropDown 											= this.plugDropDown.bind(this)
		this.toolsDropDown 											= this.toolsDropDown.bind(this)


		this.getToolCheckBox 										= this.getToolCheckBox.bind(this)
		// Обработка дропдаунов
		this.onBrandChange 											= this.onBrandChange.bind(this);
		this.onShieldTypeChange 								= this.onShieldTypeChange.bind(this);
		this.onShieldAvailChange 								= this.onShieldAvailChange.bind(this);
		this.onShellChange 											= this.onShellChange.bind(this);
		this.onShellColorChange 								= this.onShellColorChange.bind(this);
		this.onCategoryChange 									= this.onCategoryChange.bind(this);

		this.onConnectorTypeChange 							= this.onConnectorTypeChange.bind(this);
		this.onPortsChange 											= this.onPortsChange.bind(this);
		this.onFrequencyChange 									= this.onFrequencyChange.bind(this);
		this.onTerminationTypeChange 						= this.onTerminationTypeChange.bind(this);
		this.onMountingTypeChange 							= this.onMountingTypeChange.bind(this);

		this.onPatchPortsChange 								= this.onPatchPortsChange.bind(this);
		this.onPatchConnectionTypeChange 				= this.onPatchConnectionTypeChange.bind(this);
		this.onPatchTerminationTypeChange 			= this.onPatchTerminationTypeChange.bind(this);
		this.onCableOrgChange 									= this.onCableOrgChange.bind(this);
		this.onPatchMountTypeChange 						= this.onPatchMountTypeChange.bind(this);
		this.onBandwidthChange 									= this.onBandwidthChange.bind(this);

		this.onPatchCordLengthChange 						= this.onPatchCordLengthChange.bind(this);
		this.onPatchCordColorChange 						= this.onPatchCordColorChange.bind(this);
		this.onPatchCordConnectorTypeChange 		= this.onPatchCordConnectorTypeChange.bind(this);
		this.onPatchCordExternalChange 					= this.onPatchCordExternalChange.bind(this);
		this.onPatchCordInternalChange 					= this.onPatchCordInternalChange.bind(this);

		this.onInsertNumChange 									= this.onInsertNumChange.bind(this);

		this.onKoaksInternMatChange 						= this.onKoaksInternMatChange.bind(this);
		this.onKoaksCableBrandChange 						= this.onKoaksCableBrandChange.bind(this);

		this.onAddDiviceChange									= this.onAddDiviceChange.bind(this);

		this.onPlugTypeChange										= this.onPlugTypeChange.bind(this);
		this.onAwgChange												= this.onAwgChange.bind(this);
		this.onPlugDiamChange										= this.onPlugDiamChange.bind(this);

		this.onCompatibilityChange							= this.onCompatibilityChange.bind(this);
		this.onDiamAWGChange										= this.onDiamAWGChange.bind(this);


		//Обработка чекбоксов
		this.onRatchetChange 										= this.onRatchetChange.bind(this);
		this.onPercussionChange 								= this.onPercussionChange.bind(this);
		this.onCompressFChange 									= this.onCompressFChange.bind(this);
		this.onConnectorFChange 								= this.onConnectorFChange.bind(this);
		this.onLsaChange 												= this.onLsaChange.bind(this);
		this.onRJChange 												= this.onRJChange.bind(this);
		this.onFixToolChange 										= this.onFixToolChange.bind(this);
		this.onCutToolChange 										= this.onCutToolChange.bind(this);
		this.onClearChange 											= this.onClearChange.bind(this);
		this.onDeepChange 											= this.onDeepChange.bind(this);


		// Обработка событий таблиц
		this.onChangeQuantity 									= this.onChangeQuantity.bind(this);
		this.addBasket 													= this.addBasket.bind(this);
		this.onDelete 													= this.onDelete.bind(this);

		//Служебные процедуры
		this.getItemList 												= this.getItemList.bind(this);
		this.getArrayFromAttribute 							= this.getArrayFromAttribute.bind(this);
		this.filterArray 												= this.filterArray.bind(this);
		this.filterArrayByCat 									= this.filterArrayByCat.bind(this);
		this.getOptions 												= this.getOptions.bind(this);

		this.koaksChosen 												= this.koaksChosen.bind(this);
		this.lanChosen 													= this.lanChosen.bind(this);

		this.changeLanFilterOptions 						= this.changeLanFilterOptions.bind(this);
		this.getFilteredLanArray 								= this.getFilteredLanArray.bind(this);

		this.openPlug 													= this.openPlug.bind(this);
		this.getFilteredPlugArray 							= this.getFilteredPlugArray.bind(this);
		this.changePlugFilterOptions 						= this.changePlugFilterOptions.bind(this);

		this.openModule 												= this.openModule.bind(this);
		this.getFilteredModuleArray 						= this.getFilteredModuleArray.bind(this);
		this.changeModuleFilterOptions 					= this.changeModuleFilterOptions.bind(this);

		this.openPatchPanel											= this.openPatchPanel.bind(this);
		this.getFilteredPatchPanelArray 				= this.getFilteredPatchPanelArray.bind(this);
		this.changePatchPanelFilterOptions 			= this.changePatchPanelFilterOptions.bind(this);

		this.openPatchCord											= this.openPatchCord.bind(this);
		this.getFilteredPatchCordArray 					= this.getFilteredPatchCordArray.bind(this);
		this.changePatchCordFilterOptions 			= this.changePatchCordFilterOptions.bind(this);

		this.openTools													= this.openTools.bind(this);
		this.getFilteredToolsArray 							= this.getFilteredToolsArray.bind(this);
		this.changeToolsFilterOptions 					= this.changeToolsFilterOptions.bind(this);

		this.changeKoaksFilterOptions 					= this.changeKoaksFilterOptions.bind(this);
		this.getFilteredKoaksArray 							= this.getFilteredKoaksArray.bind(this);

		this.getListFromCheckBox 								= this.getListFromCheckBox.bind(this);

		this.onClearFiltersClick 								= this.onClearFiltersClick.bind(this);
		this.doPrint 														= this.doPrint.bind(this);
		this.onBtnExcelClick 										= this.onBtnExcelClick.bind(this);

		this.mainDropDownChangeHandler          = this.mainDropDownChangeHandler.bind(this);
		this.addDropDownChangeHandler           = this.addDropDownChangeHandler.bind(this);
		this.checkBoxChangeHandler          		= this.checkBoxChangeHandler.bind(this);



	}


	getItemList(groupId){
		return jQuery.getJSON(
			'itkcfg.php',
			{
				type: this.getType(),
				action: 'getItemListNSI',
				groupId:groupId
			},
			items => items);
	}


// ++ Работа таблиц

	//Отображение выбранного значения
	onListItemCheck(item) {
		super.onListItemCheck(item.article)
	}

	// Добавить элемент в корзину
	addBasket(item) {
		jQuery.getJSON(
			'itkcfg.php',
			{
				type: 'lan',
				action: 'getItemPriceNSI',
				article: item.article,
				groupId: '20'
			},	result => {
				let price = result[0].price

				this.setState(prevState => {
					const specList = [...prevState.specList]
					if (specList.some(i => i.article === item.article)) {
						specList.map(i => {
							if(i.article === item.article) {
								i.count = Number(i.count) + 1
								i.sum = (i.price*i.count).toFixed(2)
							}
							return i
						})
					} else {
						item.count = 1
						item.sum = (item.count*price).toFixed(2)
						item = {...item, 'price': price}
						specList.push(item)
					}
					let summ = specList.map(item => item.price*item.count).reduce((previousValue, currentValue) => {
						return previousValue + currentValue
					}).toFixed(2)
					return {specList, summ}
				})
			})
	}

	//Удаление
	onDelete(item) {

		this.setState((prevState) => {
			return {
				...prevState,
				specList: prevState.specList.filter((el) => el.article !== item.article)
			}
		}, ()=>{
			let specList = this.state.specList
			let summ = 0
			if(specList.length){
				summ= specList.map(item => item.price).reduce((previousValue, currentValue) => {
					return previousValue + currentValue
				}).toFixed(2)
			}
			this.setState({summ})
		})

	}

	// изменение количества позиции
	onChangeQuantity(item, value) {

		this.setState(prevState => {
			const newBasket = prevState.specList.map(i => {
				if (i.article === item.article) {
					i.count = value
					i.sum = (value*item.price).toFixed(2)
				}
				return i
			})

			let summ = prevState.specList.map(item => item.price*item.count).reduce((previousValue, currentValue) => {
				return previousValue + currentValue
			}).toFixed(2)

			return {
				specList: newBasket,
				summ
			}
		})
	}

// -- Работа таблиц

// ++ Для Запуска
	getType() {
		return 'lan';
	}

	getCustomStyles() {
		return styles;
	}

	// -- Для Запуска

// ++ Дропдауны

// ++ Главный Дропдаун
	mainDropDown(){
		let elements = [];

		elements.push(<DropDown type='brand' x={40} y={168} header='Марка:' key={'main'+1} app={this}/> )
		elements.push(<DropDown type='shieldType' x={40} y={218} header='Тип экрана:' key={'main'+2} app={this}/> )
		elements.push(<DropDown type='shieldAvail' x={320} y={168} header='Наличие экрана:' key={'main'+3} app={this}/> )
		elements.push(<DropDown type='shell' x={180} y={168} header='Материал оболочки:' key={'main'+4} app={this}/> )
		elements.push(<DropDown type='shellColor' x={180} y={218} header='Цвет оболочки:' key={'main'+5} app={this}/> )
		elements.push(<DropDown type='category' x={320} y={218} header='Категория:' key={'main'+6} app={this}/> )

		return elements;
	}
// -- Главный Дропдаун

//++ Модули
  moduleDropDown(){
		let elements = [];
		elements.push(<DropDown type='connectorType' x={40} y={418} header='Тип разъема:' key={'module'+1} app={this}/> )
		elements.push(<DropDown type='ports' x={40} y={468} header='Количество портов:' key={'module'+2} app={this}/>)
		elements.push(<DropDown type='frequency' x={320} y={418} header='Рабочая частота, МГц:' key={'module'+3} app={this}/>)
		elements.push(<DropDown type='terminationType' x={180} y={418} header='Тип заделки:' key={'module'+4} app={this}/>)
		elements.push(<DropDown type='mountingType' x={180} y={468} header='Тип монтажа:' key={'module'+5} app={this}/>)
		return elements;
}
//-- Модули

// ++ Патч-панели
	patchPanelDropDown(){
		let elements = [];
		elements.push(<DropDown type='patchPorts' x={40} y={418} header='Количество портов:' key={'patchPanel'+1} app={this}/> )
		elements.push(<DropDown type='patchConnectionType' x={40} y={468} header='Тип соединения:' key={'patchPanel'+2} app={this}/> )
		elements.push(<DropDown type='patchTerminationType' x={320} y={418} header='Тип заделки:' key={'patchPanel'+3} app={this}/> )
		elements.push(<DropDown type='cableOrg' x={180} y={418} header='Кабельный органайзер:' key={'patchPanel'+4} app={this}/> )
		elements.push(<DropDown type='patchMountType' x={180} y={468} header='Тип монтажа:' key={'patchPanel'+5} app={this}/> )
		elements.push(<DropDown type='bandwidth' x={320} y={468} header='Полоса пропускания:' key={'patchPanel'+6} app={this}/> )

			return elements;
	}
// -- Патч-панели

// ++ Патч-корды
	patchCordDropDown(){
		let elements = [];
		elements.push(<DropDown type='patchCordLength' x={40} y={418} header='Длинна, м:' key={'patchCord'+1} app={this}/> )
		elements.push(<DropDown type='patchCordColor' x={40} y={468} header='Цвет оболочки:' key={'patchCord'+2} app={this}/> )
		elements.push(<DropDown type='patchCordConnectorType' x={180} y={418} header='Тип коннекторов:' key={'patchCord'+3} app={this}/> )
		elements.push(<DropDown type='patchCordExternal' x={320} y={418} header='Внешний диаметр, мм:' key={'patchCord'+4} app={this}/> )
		elements.push(<DropDown type='patchCordInternal' x={180} y={468} header='Диаметр жилы, мм:' key={'patchCord'+5} app={this}/> )
		return elements;
	}
// -- Патч-корды

	// ++ Коаксиальный кабель
	koaksCableDropDown(){
		let elements = [];
		elements.push(<DropDown type='koaksInternMat' x={40} y={168} header='Материал внутри проводника:' key={'koaks'+1} app={this}/> )
		elements.push(<DropDown type='koaksCableBrand' x={230} y={168} header='Материал оболочки:' key={'koaks'+2} app={this}/> )

		return elements
	}
// -- Коаксиальный кабель

// ++ Разъемы
	plugDropDown(){
	let elements = [];
	elements.push(<DropDown type='plugType' x={40} y={415} header='Тип разъем:' key={'plug'+1} app={this}/> )
	elements.push(<DropDown type='awg' x={180} y={415} header='Класс-ия по AWG:' key={'plug'+2} app={this}/> )
	elements.push(<DropDown type='plugDiam' x={320} y={415} header='Диаметр провод., мм:' key={'plug'+3} app={this}/> )
	return elements
}

// -- Разъемы

	// ++ Инструменты
	toolsDropDown(){
		let elements = [];
		elements.push(<DropDown type='compatibility' x={40} y={590} header='Совместимость:' key={'tools'+1} app={this}/> )
		elements.push(<DropDown type='diamAWG' x={180} y={590} header='Диаметр кабеля по AWG:' key={'tools'+2} app={this}/> )
		return elements

	}

// -- Инструменты

// -- Дропдауны


// ++ Чекбоксы
	getToolCheckBox(){
		let elements = [];

		elements.push(<CustomeCheckBox type='ratchet' x={40} lableY={417} y={415} header='Храповый механизм:' key={'toolCB'+1} app={this}/> )
		elements.push(<CustomeCheckBox type='percussion' x={260} lableY={417} y={415} header='Ударный механизм:' key={'toolCB'+2} app={this}/> )
		elements.push(<CustomeCheckBox type='compressF' x={40} lableY={442} y={445} header='Подходит к компресс разъему типа F:' key={'toolCB'+3} app={this}/> )
		elements.push(<CustomeCheckBox type='connectorF' x={260} lableY={442} y={445} header='Подходит для разъема типа F:' key={'toolCB'+4} app={this}/> )
		elements.push(<CustomeCheckBox type='lsa' x={40} lableY={477} y={480} header='Подходит для плинта LSA-plus:' key={'toolCB'+5} app={this}/> )
		elements.push(<CustomeCheckBox type='RJ' x={260} lableY={477} y={480} header='Подходит для разъема типа RJ:' key={'toolCB'+6} app={this}/> )
		elements.push(<CustomeCheckBox type='fixTool' x={40} lableY={512} y={515} header='С фиксирующим устройством:' key={'toolCB'+7} app={this}/> )
		elements.push(<CustomeCheckBox type='cutTool' x={260} lableY={512} y={512} header='С отрезным устройством:' key={'toolCB'+8} app={this}/> )
		elements.push(<CustomeCheckBox type='clear' x={40} lableY={547} y={550} header='С функцией зачистки кабеля:' key={'toolCB'+9} app={this}/> )
		elements.push(<CustomeCheckBox type='deep' x={260} lableY={547} y={550} header='Регулируемая глубина надреза:' key={'toolCB'+10} app={this}/> )
		return elements
	}
// -- Чекбоксы


	// ++Кнопки
	getCustomButtons() {
		let elements = [];

		elements.push(
			<Button
				x="736"
				y="764"
				buttonStyle={styles.mainBtn}
				textStyle={styles.mainBtnText}
				iconStyle={styles.pdfBtnIcon}
				text="Сохранить в PDF"
				onClick={this.onBtnPrintPdfClick}
				key="printpdf"
			/>
		);

		elements.push(
			<Button
				x="940"
				y="764"
				buttonStyle={styles.mainBtn}
				textStyle={styles.mainBtnText}
				iconStyle={styles.printBtnIcon}
				text="Распечатать"
				onClick={this.onBtnPrintClick}
				key="print"
			/>
		);

		elements.push(
			<Button
				x="1144"
				y="764"
				buttonStyle={styles.mainBtn}
				textStyle={styles.mainBtnText}
				iconStyle={styles.excelBtnIcon}
				text="Сохранить в Excel"
				onClick={this.onBtnExcelClick}
				key="excel"
			/>
		);



		return elements;
	}
	//-- Кнопки

	onClearFiltersClick(){

		let obj =  {
			addFilterEnabled: false,
			filterAddDivice:'Выбрать',
			...initialAddState,
			...initialLanState,
			...initialKoaksState,
			itemList:this.state.lanList,
		}
		if(this.state.tabType === "Lan"){
			obj = {
				...obj,
				tableHeight: '390px',
				tableTop: '363px',
			}
		}else if(this.state.tabType === 'Koaks'){
				obj = {
					...obj,
					tableHeight: '488px',
					tableTop: '277px',
				}
		}

		this.setState(obj,()=>{
			this.state.tabType === "Lan" ?
				this.changeLanFilterOptions(this.state.lanList)
				:
				this.changeKoaksFilterOptions(this.state.koaksList)
		})
	}

// ++ Обработка выбора кабеля

	lanChosen(){
		if(this.state.tabType === 'Lan') return

		this.changeLanFilterOptions(this.state.lanList)

		this.setState({
			tabType: 'Lan',
			tableHeight: '390px',
			tableTop: '363px',
			itemList: this.state.lanList,
			addFilterEnabled:false,
			...initialAddState,
			...initialLanState,
			...initialKoaksState
		})

	}

	koaksChosen(){

		if(this.state.tabType === 'Koaks') return

		this.changeKoaksFilterOptions(this.state.koaksList)

		this.setState({
			tabType: 'Koaks',
			tableHeight: '505px',
			tableTop: '247px',
			filterAddDivice:'Выбрать',
			itemList:this.state.koaksList,
			...initialAddState,
			...initialLanState,
			...initialKoaksState
		})
	}
// -- Обработка выбора кабеля

// ++ Обработка Событий

// ++ Дропдауны
	onBrandChange(event){
		this.mainDropDownChangeHandler( 'brand', event.target.value)
	}

	onShieldTypeChange(event){
		this.mainDropDownChangeHandler( 'screen_type', event.target.value)
	}

	onShieldAvailChange(event){
		this.mainDropDownChangeHandler( 'screen_pres', event.target.value)
	}

	onShellChange(event){
		this.mainDropDownChangeHandler( 'outer_shell_mat', event.target.value)
	}

	onShellColorChange(event){
		this.mainDropDownChangeHandler( 'outer_shell_col', event.target.value)
	}

	onCategoryChange(event){
		this.mainDropDownChangeHandler( 'category', event.target.value)
	}


	onConnectorTypeChange(event){
		this.addDropDownChangeHandler('Module', 'plug_type', event.target.value)
	}

	onPortsChange(event){
		this.addDropDownChangeHandler('Module', 'ports_numb', event.target.value)
	}

	onFrequencyChange(event){
		this.addDropDownChangeHandler('Module', 'freq', event.target.value)
	}

	onTerminationTypeChange(event){
		this.addDropDownChangeHandler('Module', 'idc_type', event.target.value)
	}

	onMountingTypeChange(event){
		this.addDropDownChangeHandler('Module', 'mount_type', event.target.value)
	}


	onPatchPortsChange(event){
		this.addDropDownChangeHandler('PatchPanel', 'ports_numb', event.target.value)
	}

	onPatchConnectionTypeChange(event){
		this.addDropDownChangeHandler('PatchPanel', 'plug_type', event.target.value)
	}

	onPatchTerminationTypeChange(event){
		this.addDropDownChangeHandler('PatchPanel', 'idc_type', event.target.value)
	}

	onCableOrgChange(event){
		this.addDropDownChangeHandler('PatchPanel','cable_org', event.target.value)
	}

	onPatchMountTypeChange(event){
		this.addDropDownChangeHandler('PatchPanel','mount_type', event.target.value)
	}

	onBandwidthChange(event){
		this.addDropDownChangeHandler('PatchPanel','bandwidth', event.target.value)
	}

	onPatchCordLengthChange(event){
		this.addDropDownChangeHandler('PatchCord','length', event.target.value)
	}

	onPatchCordColorChange(event){
		this.addDropDownChangeHandler('PatchCord','outer_shell_col', event.target.value)
	}

	onPatchCordConnectorTypeChange(event){
		this.addDropDownChangeHandler('PatchCord','cable_type', event.target.value)
	}

	onPatchCordExternalChange(event){
		this.addDropDownChangeHandler('PatchCord','cable_out_diam', event.target.value)
	}

	onPatchCordInternalChange(event){
		this.addDropDownChangeHandler('PatchCord','core_diam', event.target.value)
	}

	onInsertNumChange(event){
		this.addDropDownChangeHandler('ModuleInserts','ports_numb', event.target.value)
	}

	onKoaksInternMatChange(event){

		let value = event.target.value

		let itemList = this.getFilteredKoaksArray(value, 'koaksInternMat')
		this.changeKoaksFilterOptions(itemList, value, 'koaksInternMat')

		this.setState({
			filterKoaksInternMat: value,
			itemList
		})

	}

	onKoaksCableBrandChange(event){

		let value = event.target.value

		let itemList = this.getFilteredKoaksArray(value, 'koaksCableBrand')
		this.changeKoaksFilterOptions(itemList, value, 'koaksCableBrand')

		this.setState({
			filterKoaksCableBrand: value,
			itemList
		})
	}

	onAddDiviceChange(event){

		let deviseType = event.target.value
		this.setState({
			filterAddDivice:deviseType
		},()=>{

			let tableHeight = '390px'
			let tableTop = '363px'

			switch (this.state.filterAddDivice) {
				case 'plug':
					tableHeight = '258px'
					tableTop = '495px'
					this.openPlug()
					break;

				case 'tool':
					tableHeight = '82px'
					tableTop = '672px'
					this.openTools()
					break;

				case 'module':
					tableHeight = '207px'
					tableTop = '545px'
					this.openModule()
					break;

				case 'patch_panel':
					tableHeight = '207px'
					tableTop = '545px'
					this.openPatchPanel()
					break;

				case 'patch_cord':
					tableHeight = '207px'
					tableTop = '545px'
					this.openPatchCord()
					break;

				case 'Выбрать':
					let itemList = this.getFilteredLanArray()
					this.setState({itemList})
					break;
			}

			this.setState({
				tableHeight,
				tableTop,
				...initialAddState
			})
		});
	}

	onPlugTypeChange(event){
		this.addDropDownChangeHandler('Plug','plug_type', event.target.value)
	}

	onAwgChange(event){
		this.addDropDownChangeHandler('Plug','awg_type', event.target.value)
	}

	onPlugDiamChange(event){
		this.addDropDownChangeHandler('Plug','con_cond_diam', event.target.value)
	}

	onCompatibilityChange(event){
		this.addDropDownChangeHandler('Tools','compatibility', event.target.value)
	}

	onDiamAWGChange(event){
		this.addDropDownChangeHandler('Tools','awg_diam', event.target.value)
	}

	// -- Дропдауны


// ++ ЧекБоксы
	onRatchetChange(){
		this.checkBoxChangeHandler('Tools', 'ratchet', !this.state.ratchet)
	}

	onPercussionChange(){
		this.checkBoxChangeHandler('Tools', 'impact', !this.state.percussion)
	}

	onCompressFChange(){
		this.checkBoxChangeHandler('Tools', 'compress_plug_f', !this.state.compressF)
	}

	onConnectorFChange(){
		this.checkBoxChangeHandler('Tools', 'plug_f', !this.state.connectorF)
	}

	onLsaChange(){
		this.checkBoxChangeHandler('Tools', 'lsa_plus', !this.state.lsa)
	}

	onRJChange(){
		this.checkBoxChangeHandler('Tools', 'rj_plus', !this.state.RJ)
	}

	onFixToolChange(){
		this.checkBoxChangeHandler('Tools', 'fix', !this.state.fixTool)
	}

	onCutToolChange(){
		this.checkBoxChangeHandler('Tools', 'cut', !this.state.cutTool)
	}

	onClearChange(){
		this.checkBoxChangeHandler('Tools', 'clean', !this.state.clear)
	}

	onDeepChange(){
		this.checkBoxChangeHandler('Tools', 'cut_deep', !this.state.deep)
	}
// -- ЧекБоксы


	// ++ Обработка печати
	doPrint(params) {
		let _params = params || {};
		_params.data = {
			specList: JSON.stringify(this.state.specList)
		};
		super.doPrint(_params);
	}

	onBtnExcelClick() {
		this.doPrint({format: 'xls'});
	}
// -- Обработка печати

// -- Обработка Событий

	// ++ Служебные процедуры и функции
	mainDropDownChangeHandler(filterType, value){
		let obj
		let itemList = this.getFilteredLanArray(value, filterType)
		this.changeLanFilterOptions(itemList, value, filterType)

		obj={itemList}

		if(this.state.addFilterEnabled){
			obj={
				...obj,
				filterAddDivice:'Выбрать',
				addFilterEnabled:false,
				tableHeight: '390px',
				tableTop: '363px',
			}
		}

		switch (filterType) {
			case 'brand': obj = {...obj, filterBrand: value}; break;
			case 'screen_type': obj = {...obj, filterShieldType: value}; break;
			case 'screen_pres': obj = {...obj, filterShieldAvail: value}; break;
			case 'outer_shell_mat': obj = {...obj, filterShell: value}; break;
			case 'outer_shell_col': obj = {...obj, filterShellColor: value}; break;
			case 'category': obj = {...obj, filterCategory: value}; break;
		}
		this.setState(obj)

	}

	addDropDownChangeHandler(groupType, filterType, value){

		let itemList = this.getFilteredLanArray()
		let obj = {}
		let	addList = this['getFiltered' + groupType + 'Array'](value, filterType)
		this['change' + groupType + 'FilterOptions'](addList, value, filterType)
		switch (groupType) {
			case 'Module':
				switch (filterType) {
					case 'plug_type': obj = {filterConnectorType: value}; break;
					case 'ports_numb': obj = {filterPorts: value}; break;
					case 'freq': obj = {filterFrequency: value}; break;
					case 'idc_type': obj = {filterTerminationType: value}; break;
					case 'mount_type': obj = {filterMountingType: value}; break;
				}break;
			case 'PatchPanel':
				switch (filterType) {
					case 'ports_numb': obj = {filterPatchPorts: value}; break;
					case 'plug_type': obj = {filterPatchConnectionType: value}; break;
					case 'idc_type': obj = {filterPatchTerminationType: value}; break;
					case 'cable_org': obj = {filterCableOrg: value}; break;
					case 'mount_type': obj = {filterPatchMountType: value}; break;
					case 'bandwidth': obj = {filterBandwidth: value}; break;
				}break;
			case 'PatchCord':
				switch (filterType) {
					case 'length': obj = {filterPatchCordLength: value}; break;
					case 'outer_shell_col': obj = {filterPatchCordColor: value}; break;
					case 'cable_type': obj = {filterPatchCordConnectorType: value}; break;
					case 'cable_out_diam': obj = {filterPatchCordExternal: value}; break;
					case 'core_diam': obj = {filterPatchCordInternal: value}; break;
				}break;
			case 'ModuleInserts':
				switch (filterType) {
					case 'ports_numb': obj = {filterInsertNum: value}; break;
				}break;
			case 'Plug':
				switch (filterType) {
					case 'plug_type': obj = {filterPlugType: value}; break;
					case 'awg_type': obj = { filterAwg: value}; break;
					case 'con_cond_diam': obj = {filterPlugDiam: value}; break;
				}break;
			case 'Tools':
				switch (filterType) {
					case 'compatibility': obj = {filterCompatibility: value}; break;
					case 'awg_diam': obj = {filterDiamAWG: value}; break;
				}break;
		}

		itemList = itemList.concat(addList)
		obj ={...obj, itemList}

		this.setState(obj)
	}

	checkBoxChangeHandler(groupType, filterType, value){

		let itemList = this.getFilteredLanArray()
		let obj = {}
		let	addList = this['getFiltered' + groupType + 'Array'](value, filterType)
		this['change' + groupType + 'FilterOptions'](addList, value, filterType)
		switch (groupType) {
			case 'Tools':
				switch (filterType) {
					case 'ratchet': obj = {ratchet: value}; break;
					case 'impact': obj = {percussion: value}; break;
					case 'compress_plug_f': obj = {compressF: value}; break;
					case 'plug_f': obj = {connectorF: value}; break;
					case 'lsa_plus': obj = {lsa: value}; break;
					case 'rj_plus': obj = {RJ: value}; break;
					case 'fix': obj = {fixTool: value}; break;
					case 'cut': obj = {cutTool: value}; break;
					case 'clean': obj = {clear: value}; break;
					case 'cut_deep': obj = {deep: value}; break;
				}break;
		}

		itemList = itemList.concat(addList)

		obj ={...obj, itemList}

		this.setState(obj)

	}


	getFilteredLanArray(value , type ){

		let itemList = this.state.lanList

		let brand =								type === 'brand' ? value : this.state.filterBrand
		let screenType =					type === 'screen_type' ? value : this.state.filterShieldType
		let screenPres =					type === 'screen_pres' ? value : this.state.filterShieldAvail
		let outerShellMat =				type === 'outer_shell_mat' ? value : this.state.filterShell
		let outerShellCol =				type === 'outer_shell_col' ? value : this.state.filterShellColor
		let category =						type === 'category' ? value : this.state.filterCategory

		// Фильтруем список по марке
		if (brand !== 'Выбрать') 					itemList = itemList.filter(item => item.TM === brand)

		// Фильтруем список по типу экрана
		if (screenType !== 'Выбрать') 		itemList = itemList.filter(item => item.screen_type === screenType)

		// Фильтруем список по наличиию экрана
		if (screenPres !== 'Выбрать'){
			itemList = itemList.filter(item =>{
				let intArray = item.Features.filter(item => {return item.Attribute === SCREEN_PRES})
				if (intArray.length>0){
					return screenPres === 'Нет' ? intArray[0].value === screenPres : intArray[0].value !== 'Нет'
				}
			})
			itemList = itemList.filter(item => (item))
		}

		// Фильтруем список по материалу внешней оболочки
		itemList = this.filterArray(outerShellMat,itemList, OUTER_SHELL_MATERIAL)

		// Фильтруем список по цвету внешней оболочки
		itemList = this.filterArray(outerShellCol,itemList, OUTER_SHELL_COLOR)

		// Фильтруем список по категории
		itemList = this.filterArrayByCat(category, itemList)

		return itemList

	}

	changeLanFilterOptions(itemList, value , type ){
		let addFilterEnabled = true
		let brand =								type === 'brand' ? value : this.state.filterBrand
		let screenType =					type === 'screen_type' ? value : this.state.filterShieldType
		let screenPres =					type === 'screen_pres' ? value : this.state.filterShieldAvail
		let outerShellMat =				type === 'outer_shell_mat' ? value : this.state.filterShell
		let outerShellCol =				type === 'outer_shell_col' ? value : this.state.filterShellColor
		let category =						type === 'category' ? value : this.state.filterCategory

		let brandOptions		 				= this.state.brandOptions
		let shieldTypeOptions 			= this.state.shieldTypeOptions
		let shieldAvailOptions 			= this.state.shieldAvailOptions
		let shellOptions 						= this.state.shellOptions
		let shellColorOptions 			= this.state.shellColorOptions
		let categoryOptions 				= this.state.categoryOptions

		//Выбор марки
		if (brand === 'Выбрать'){
			brandOptions = this.getOptions(itemList, 'TM')
			addFilterEnabled = false
		}

		//Выбор типа экрана
		if (screenType === 'Выбрать'){
			shieldTypeOptions = this.getOptions(itemList, 'screen_type')
			addFilterEnabled = false
		}

		//Выбор наличия экрана
		if (screenPres === 'Выбрать'){
			let result = itemList.map(item => {
				let intArray = item.Features.filter(item => {
					return item.Attribute === SCREEN_PRES
				})
				if (intArray.length>0){
					return intArray[0].value === 'Нет' ? 'Нет' : 'Да'
				}
			})
			shieldAvailOptions = this.delDuplicatesFromArray(result.filter(item => (item)))
			shieldAvailOptions.unshift('Выбрать')
			addFilterEnabled = false
		}

		//Выбор материала внешней оболочки
		if (outerShellMat === 'Выбрать') {
			shellOptions = this.getArrayFromAttribute(itemList, OUTER_SHELL_MATERIAL)
			addFilterEnabled = false
		}

		// //Выбор цвета внешней оболочки
		if (outerShellCol === 'Выбрать') {
			shellColorOptions = this.getArrayFromAttribute(itemList, OUTER_SHELL_COLOR)
			addFilterEnabled = false
		}

		// //Выбор категории
		if (category === 'Выбрать') {
			let fullArray = itemList.map(item => {
				let intArray = item.Features.filter(item => {
					return item.Attribute === CATEGORY_NAME
				})
				if (intArray.length>0){
					return intArray[0].value.split(' ')[0];
				}
			})
			fullArray = fullArray.filter(item => (item))
			let result = this.delDuplicatesFromArray(fullArray)
			categoryOptions = result.map(item => item.trim())
			categoryOptions.unshift('Выбрать')

			addFilterEnabled = false
		}

			return this.setState({
				brandOptions,
				shieldTypeOptions,
				shieldAvailOptions,
				shellOptions,
				shellColorOptions,
				categoryOptions,
				addFilterEnabled
			})
	}

	getFilteredKoaksArray(value , type ){

		let itemList = this.state.koaksList

		let koaksInternMat =					type === 'koaksInternMat' ? value : this.state.filterKoaksInternMat
		let koaksCableBrand =					type === 'koaksCableBrand' ? value : this.state.filterKoaksCableBrand

		// Фильтруем список по материалу внутри проводника
		itemList = this.filterArray(koaksInternMat,itemList, INNER_MATERIAL)

		// Фильтруем список по материалу внутри проводника
		itemList = this.filterArray(koaksCableBrand,itemList, CABLE_BRAND)

		return itemList
	}

	changeKoaksFilterOptions(itemList, value, type){

		let koaksInternMat =					type === 'koaksInternMat' ? value : this.state.filterKoaksInternMat
		let koaksCableBrand =					type === 'koaksCableBrand' ? value : this.state.filterKoaksCableBrand

		let koaksInternMatOptions		  = this.state.koaksInternMatOptions
		let koaksCableBrandOptions 		= this.state.koaksCableBrandOptions

		//Выбор вариантов внтуреннего материала кабеля
		if (koaksInternMat === 'Выбрать'){
			koaksInternMatOptions = this.getArrayFromAttribute(itemList, INNER_MATERIAL)
		}

		//Выбор вариантов марки кабеля
		if (koaksCableBrand === 'Выбрать'){
			koaksCableBrandOptions = this.getArrayFromAttribute(itemList, CABLE_BRAND)
		}

		return this.setState({koaksInternMatOptions, koaksCableBrandOptions})

	}


	// Разъемы
	openPlug(){
		let itemList = this.getFilteredLanArray()
		let list = this.getFilteredPlugArray()

		this.changePlugFilterOptions(list)

		itemList = itemList.concat(list)

		this.setState({itemList})
	}

	getFilteredPlugArray(value, type){

		let category 				= this.state.filterCategory
		let screenPres 			= this.state.filterShieldAvail

		let plugType =						type === 'plug_type' ? value : this.state.filterPlugType
		let awgType =							type === 'awg_type' ? value : this.state.filterAwg
		let conCondDiam =					type === 'con_cond_diam' ? value : this.state.filterPlugDiam

		let list = this.state.plugList

		//Фильтруем список разъёмов
		list = this.filterArrayByCat(category, list)

		list = this.filterArray(screenPres,list, ADD_SCREEN_PRES)

		list = this.filterArray(plugType,list, CONNECTOR_TYPE)

		list = this.filterArray(awgType,list, AWG_TYPE)

		list = this.filterArray(conCondDiam,list, CABLE_DIAM)

		return list
	}

	changePlugFilterOptions(itemList, value, type){

		let plugType =						type === 'plug_type' ? value : this.state.filterPlugType
		let awgType =							type === 'awg_type' ? value : this.state.filterAwg
		let conCondDiam =					type === 'con_cond_diam' ? value : this.state.filterPlugDiam

		let plugTypeOptions		  	= this.state.plugTypeOptions
		let awgOptions 						= this.state.awgOptions
		let plugDiamOptions 			= this.state.plugDiamOptions

		//Выбор типа разъема
		if (plugType === 'Выбрать') 				plugTypeOptions = this.getArrayFromAttribute(itemList, CONNECTOR_TYPE)

		//Выбор вариантов классификации по AWG
		if (awgType === 'Выбрать') 					awgOptions = this.getArrayFromAttribute(itemList, AWG_TYPE)

		//Выбор вариантов диаметра подключаемых проводников мм
		if (conCondDiam === 'Выбрать')			plugDiamOptions = this.getArrayFromAttribute(itemList, CABLE_DIAM)

		return this.setState({
			plugTypeOptions,
			awgOptions,
			plugDiamOptions,
		})
	}

	// Модули
	openModule(){
		let itemList = this.getFilteredLanArray()
		let list = this.getFilteredModuleArray()

		this.changeModuleFilterOptions(list)

		itemList = itemList.concat(list)

		this.setState({itemList})
	}

	getFilteredModuleArray(value, type){

		let brand 					= this.state.filterBrand
		let category 				= this.state.filterCategory
		let screenPres 			= this.state.filterShieldAvail
		let screenType 			= this.state.filterShieldType

		let plugType 				= type === 'plug_type' ? value : this.state.filterConnectorType
		let portsNumb 			= type === 'ports_numb' ? value : this.state.filterPorts
		let idcType 				= type === 'idc_type' ? value : this.state.filterTerminationType
		let mountType 			= type === 'mount_type' ? value : this.state.filterMountingType
		let freq 						= type === 'freq' ? value : this.state.filterFrequency

		let list = this.state.moduleList

		list = this.filterArrayByCat(category, list)
		if (brand !== 'Выбрать') 					list = list.filter(item => item.TM === brand)
		if (screenType !== 'Выбрать') 					list = list.filter(item => item.name.includes(screenType[0]+'TP'))

		list = this.filterArray(plugType,list, CONNECTOR_TYPE)
		list = this.filterArray(portsNumb,list, PORT_NUMB)
		list = this.filterArray(idcType,list, IDC_TYPE)

		if (mountType !== 'Выбрать') {
			let mountTypeAttrName = ''
			switch(mountType){
				case 'На поверхность': mountTypeAttrName = 'Монтаж на поверхность_Code'; break;
				case 'Заподлицо': mountTypeAttrName = 'Монтаж заподлицо - штукатурка_Code'; break;
				case 'В напольную коробку или под полом': mountTypeAttrName = 'Монтаж в напольную коробку или под полом_Code'; break;
			}
			list = list.filter(item =>{
					let intArray = item.Features.filter(item => {return (item.Attribute === mountTypeAttrName && item.value === 'Да' ) })
					if (intArray.length>0){
						return intArray[0].value
					}
				})
			list = list.filter(item => (item))

		}

		list = this.filterArray(freq,list, FREQUENCY)

		let adapterList = this.state.adapterList
		adapterList = this.filterArrayByCat(category, adapterList)
		if (brand !== 'Выбрать') 					adapterList = adapterList.filter(item => item.TM === brand)
		adapterList = this.filterArray(screenPres,adapterList, ADD_SCREEN_PRES)

		let socketList = this.state.socketList
		if (screenType !== 'Выбрать') 					socketList = socketList.filter(item => item.name.includes(screenType[0]+'TP'))

		socketList = this.filterArray(plugType,socketList, CONNECTOR_TYPE)
		socketList = this.filterArray(portsNumb,socketList, PORT_NUMB)
		socketList = this.filterArray(freq,socketList, FREQUENCY)
		socketList = this.filterArrayByCat(category, socketList)

		let modulInsertList = this.state.modulInsertList
		modulInsertList = this.filterArray(portsNumb,modulInsertList, PORT_NUMB)

		let moduleFrameList = this.state.moduleFrameList
		moduleFrameList = this.filterArray(portsNumb,moduleFrameList, PORT_NUMB)

		if (mountType !== 'Выбрать') {
			let mountTypeAttrName = ''
			switch(mountType){
				case 'На поверхность': mountTypeAttrName = 'Монтаж на поверхность_Code'; break;
				case 'Заподлицо': mountTypeAttrName = 'Монтаж заподлицо - штукатурка_Code'; break;
				case 'В напольную коробку или под полом': mountTypeAttrName = 'Монтаж в напольную коробку или под полом_Code'; break;
			}
			moduleFrameList = moduleFrameList.filter(item =>{
				let intArray = item.Features.filter(item => {return (item.Attribute === mountTypeAttrName && item.value === 'Да' ) })
				if (intArray.length>0){
					return intArray[0].value
				}
			})
			moduleFrameList = moduleFrameList.filter(item => (item))

			modulInsertList = modulInsertList.filter(item =>{
				let intArray = item.Features.filter(item => {return (item.Attribute === mountTypeAttrName && item.value === 'Да' ) })
				if (intArray.length>0){
					return intArray[0].value
				}
			})
			modulInsertList = modulInsertList.filter(item => (item))


		}

		list = [...list, ...adapterList, ...socketList, ...modulInsertList, ...moduleFrameList]

		return list
	}

	changeModuleFilterOptions(itemList, value, type){

		let plugType 				= type === 'plug_type' ? value : this.state.filterConnectorType
		let portsNumb 			= type === 'ports_numb' ? value : this.state.filterPorts
		let idcType 				= type === 'idc_type' ? value : this.state.filterTerminationType
		let mountType 			= type === 'mount_type' ? value : this.state.filterMountingType
		let freq 						= type === 'freq' ? value : this.state.filterFrequency

		let connectorTypeOptions		  	= this.state.connectorTypeOptions
		let portsOptions		  					= this.state.portsOptions
		let terminationTypeOptions		 	= this.state.terminationTypeOptions
		let mountingTypeOptions		  		= this.state.mountingTypeOptions
		let frequencyOptions		  			= this.state.frequencyOptions


		//Выбор типа разъема
		if (plugType === 'Выбрать')			connectorTypeOptions = this.getArrayFromAttribute(itemList, CONNECTOR_TYPE)

		//Выбор количества информоционных портов
		if (portsNumb === 'Выбрать')		portsOptions = this.getArrayFromAttribute(itemList, PORT_NUMB)

		//Выбор типа IDC
		if (idcType === 'Выбрать')			terminationTypeOptions = this.getArrayFromAttribute(itemList, IDC_TYPE)

		//Выбор типа монтажа
		if (mountType === 'Выбрать'){
			mountingTypeOptions = itemList.map(item => {
				let intArray = item.Features.filter(item => {
					return (item.Attribute === 'Монтаж на поверхность_Code' || item.Attribute === 'Монтаж заподлицо - штукатурка_Code' || item.Attribute === 'Монтаж в напольную коробку или под полом_Code') && item.value === 'Да'
				})
				if (intArray.length>0){
					let result = ''
					if(intArray[0].Attribute.includes('на поверхность')) result = 'На поверхность'
					else if(intArray[0].Attribute.includes('заподлицо')) result = 'Заподлицо'
					else if(intArray[0].Attribute.includes('в напольную коробку')) result = 'В напольную коробку или под полом'
					return result
				}
			})
			mountingTypeOptions = this.delDuplicatesFromArray(mountingTypeOptions.filter(item => (item)))
			mountingTypeOptions.unshift('Выбрать')

		}
		//Выбор рабочей частоты
		if (freq === 'Выбрать')					frequencyOptions = this.getArrayFromAttribute(itemList, FREQUENCY)

		return this.setState({
			connectorTypeOptions,
			portsOptions,
			terminationTypeOptions,
			mountingTypeOptions,
			frequencyOptions,
		})
	}


	// Патч-панели
	openPatchPanel(){
		let itemList = this.getFilteredLanArray()
		let list = this.getFilteredPatchPanelArray()

		this.changePatchPanelFilterOptions(list)

		itemList = itemList.concat(list)

		this.setState({itemList})
	}

	getFilteredPatchPanelArray(value, type){

		let brand 					= this.state.filterBrand
		let category 				= this.state.filterCategory
		let screenPres 			= this.state.filterShieldAvail

		let portsNumb 			= type === 'ports_numb' ? value : this.state.filterPatchPorts
		let plugType 				= type === 'plug_type' ? value : this.state.filterPatchConnectionType
		let idcType 				= type === 'idc_type' ? value : this.state.filterPatchTerminationType
		let cableOrg 				= type === 'cable_org' ? value : this.state.filterCableOrg
		let mountType 			= type === 'mount_type' ? value : this.state.filterPatchMountType
		let bandwidth 			= type === 'bandwidth' ? value : this.state.filterBandwidth

		let list = this.state.patchPanelList
		list = this.filterArrayByCat(category, list)
		if (brand !== 'Выбрать') 					list = list.filter(item => item.TM === brand)
		list = this.filterArray(screenPres,list, ADD_SCREEN_PRES)

		list = this.filterArray(portsNumb,list, PORT_NUMB)
		list = this.filterArray(plugType,list, CONNECTOR_TYPE)
		list = this.filterArray(idcType,list, IDC_TYPE)
		list = this.filterArray(cableOrg,list, ORGANIZER)
		list = this.filterArray(mountType,list, MOUNT_TYPE)
		list = this.filterArray(bandwidth,list, BANDWIDTH)

		return list
	}

	changePatchPanelFilterOptions(itemList, value, type){

		let portsNumb 			= type === 'ports_numb' ? value : this.state.filterPatchPorts
		let plugType 				= type === 'plug_type' ? value : this.state.filterPatchConnectionType
		let idcType 				= type === 'idc_type' ? value : this.state.filterPatchTerminationType
		let cableOrg 				= type === 'cable_org' ? value : this.state.filterCableOrg
		let mountType 			= type === 'mount_type' ? value : this.state.filterPatchMountType
		let bandwidth 			= type === 'bandwidth' ? value : this.state.filterBandwidth

		let patchPortsOptions		  										= this.state.patchPortsOptions
		let patchConnectionTypeOptions		  					= this.state.patchConnectionTypeOptions
		let patchTerminationTypeOptions		 						= this.state.patchTerminationTypeOptions
		let cableOrgOptions		  											= this.state.cableOrgOptions
		let patchMountTypeOptions		  								= this.state.patchMountTypeOptions
		let bandwidthOptions		  										= this.state.bandwidthOptions

		//Выбор количества информоционных портов
		if (portsNumb === 'Выбрать')			patchPortsOptions = this.getArrayFromAttribute(itemList, PORT_NUMB)
		//Выбор типа разъема
		if (plugType === 'Выбрать')				patchConnectionTypeOptions = this.getArrayFromAttribute(itemList, CONNECTOR_TYPE)
		//Выбор типа IDC
		if (idcType === 'Выбрать')				patchTerminationTypeOptions = this.getArrayFromAttribute(itemList, IDC_TYPE)
		//Выбор органайзера
		if (cableOrg === 'Выбрать')				cableOrgOptions = this.getArrayFromAttribute(itemList, ORGANIZER)
		//Выбор типа монтажа
		if (mountType === 'Выбрать')			patchMountTypeOptions = this.getArrayFromAttribute(itemList, MOUNT_TYPE)
		//Выбор полосы пропускания
		if (bandwidth === 'Выбрать')			bandwidthOptions = this.getArrayFromAttribute(itemList, BANDWIDTH)

		return this.setState({
			patchPortsOptions,
			patchConnectionTypeOptions,
			patchTerminationTypeOptions,
			cableOrgOptions,
			patchMountTypeOptions,
			bandwidthOptions,
		})
	}


	// Патч-корды
	openPatchCord(){
		let itemList = this.getFilteredLanArray()
		let list = this.getFilteredPatchCordArray()
		this.changePatchCordFilterOptions(list)

		itemList = itemList.concat(list)

		this.setState({itemList})
	}

	getFilteredPatchCordArray(value, type){


		let brand 					= this.state.filterBrand
		let category 				= this.state.filterCategory
		let outShellMat 		= this.state.filterShell
		let screenPres 			= this.state.filterShieldAvail

		let length 					= type === 'length' ? value : this.state.filterPatchCordLength
		let color 					= type === 'outer_shell_col' ? value : this.state.filterPatchCordColor
		let plugType 				= type === 'cable_type' ? value : this.state.filterPatchCordConnectorType
		let cableOutDiam 		= type === 'cable_out_diam' ? value : this.state.filterPatchCordExternal
		let coreDiam 				= type === 'core_diam' ? value : this.state.filterPatchCordInternal

		let list = this.state.patchCordList

		//Фильтруем список разъёмов
		list = this.filterArray(outShellMat,list, COVER_TYPE)
		list = this.filterArrayByCat(category, list)
		if (brand !== 'Выбрать') 					list = list.filter(item => item.TM === brand)

		if (screenPres !== 'Выбрать'){
			list = list.filter(item =>{
				let intArray = item.Features.filter(item => {return item.Attribute === CABLE_TYPE})
				if (intArray.length>0){
					return (intArray[0].value.includes('UTP') && screenPres ==='Нет') || (screenPres ==='Да' && (intArray[0].value.includes('FTP') || intArray[0].value.includes('STP')))
				}
			})
			list = list.filter(item => (item))
		}

		list = this.filterArray(length,list, LENGTH)
		list = this.filterArray(color,list, EXT_COLOR)
		list = this.filterArray(plugType,list, CONN_TYPE)
		list = this.filterArray(cableOutDiam,list, EXT_DIAM)
		list = this.filterArray(coreDiam,list, INT_DIAM)

		return list
	}

	changePatchCordFilterOptions(itemList, value, type){

		let length 					= type === 'length' ? value : this.state.filterPatchCordLength
		let color 					= type === 'outer_shell_col' ? value : this.state.filterPatchCordColor
		let plugType 				= type === 'cable_type' ? value : this.state.filterPatchCordConnectorType
		let cableOutDiam 		= type === 'cable_out_diam' ? value : this.state.filterPatchCordExternal
		let coreDiam 				= type === 'core_diam' ? value : this.state.filterPatchCordInternal


		let patchCordLengthOptions		  								= this.state.patchCordLengthOptions
		let patchCordColorOptions		  									= this.state.patchCordColorOptions
		let patchCordConnectorTypeOptions		 						= this.state.patchCordConnectorTypeOptions
		let patchCordExternalOptions		  							= this.state.patchCordExternalOptions
		let patchCordInternalOptions		  							= this.state.patchCordInternalOptions

		//Выбор длинны
		if (length === 'Выбрать')			patchCordLengthOptions = this.getArrayFromAttribute(itemList, LENGTH)
		//Выбор цвета
		if (color === 'Выбрать')			patchCordColorOptions = this.getArrayFromAttribute(itemList, EXT_COLOR)
		//Выбор типа IDC
		if (plugType === 'Выбрать')		patchCordConnectorTypeOptions = this.getArrayFromAttribute(itemList, CONN_TYPE)
		//Выбор типа внешнего диаметра кабеля
		if (cableOutDiam === 'Выбрать')		patchCordExternalOptions = this.getArrayFromAttribute(itemList, EXT_DIAM)
		//Выбор типа внутреннего диаметра жилы
		if (coreDiam === 'Выбрать')		patchCordInternalOptions = this.getArrayFromAttribute(itemList, INT_DIAM)

		return this.setState({
			patchCordLengthOptions,
			patchCordColorOptions,
			patchCordConnectorTypeOptions,
			patchCordExternalOptions,
			patchCordInternalOptions,
		})
	}


	// Инструменты
	openTools(){

		let itemList = this.getFilteredLanArray()
		let list = this.getFilteredToolsArray()
		this.changeToolsFilterOptions(list)

		itemList = itemList.concat(list)

		this.setState({itemList})
	}

	getFilteredToolsArray(value, type){

		let result = []
		let compatibility 			= type === 'compatibility' ? value : this.state.filterCompatibility
		let awgDiam 						= type === 'awg_diam' ? value : this.state.filterDiamAWG

		let ratchet =							type === 'ratchet' ? value : this.state.ratchet
		let impact =							type === 'impact' ? value : this.state.percussion
		let compressF =						type === 'compress_plug_f' ? value : this.state.compressF
		let connectorF =					type === 'plug_f' ? value : this.state.connectorF
		let lsa =									type === 'lsa_plus' ? value : this.state.lsa
		let rj =									type === 'rj_plus' ? value : this.state.RJ
		let fix =									type === 'fix' ? value : this.state.fixTool
		let cut =									type === 'cut' ? value : this.state.cutTool
		let clear =								type === 'clean' ? value : this.state.clear
		let deep =								type === 'cut_deep' ? value : this.state.deep
		let list = this.state.toolList

		list = this.filterArray(compatibility,list, COMPABILITY)
		list = this.filterArray(awgDiam,list, AWG_DIAM)

		let cbArr = [
			{name:ratchet, dbName: RATCHET},
			{name:impact, dbName: IMPACT},
			{name:compressF, dbName: COMPRESS_F},
			{name:connectorF, dbName: PLUG_F},
			{name:lsa, dbName: LSA_PLUS},
			{name:rj, dbName: LJ_PLUS},
			{name:fix, dbName: FIX},
			{name:cut, dbName: CUT},
			{name:clear, dbName: CLEAN},
			{name:deep, dbName: CUT_DEEP},
		]
		cbArr.forEach(item=>{
			result = [...result,...this.getListFromCheckBox(list, item)]
		})
		result = this.delDuplicatesFromArray(result)
		return result

	}

	getListFromCheckBox(list, type){
		return type.name ? this.filterArray('Да',list, type.dbName) : []
	}

	changeToolsFilterOptions(itemList, value, type){

		let compatibility 								= type === 'compatibility' ? value : this.state.filterCompatibility
		let awgDiam 											= type === 'awg_diam' ? value : this.state.filterDiamAWG

		let compatibilityOptions		  		= this.state.compatibilityOptions
		let diamAWGOptions		  					= this.state.diamAWGOptions

		if (compatibility === 'Выбрать')		compatibilityOptions = this.getArrayFromAttribute(itemList, COMPABILITY)
		if (awgDiam === 'Выбрать')		diamAWGOptions = this.getArrayFromAttribute(itemList, AWG_DIAM)

		return this.setState({
			compatibilityOptions,
			diamAWGOptions
		})
	}



	getOptions(array, param){
		let result = this.delDuplicatesFromArray(array.map(item => item[param]))
		result.unshift('Выбрать')
		return result
	}


	getArrayFromAttribute(array, attribute) {
		let fullArray = array.map(item => {
			let intArray = item.Features.filter(item => {
				return item.Attribute === attribute
			})
			if (intArray.length>0){
				return intArray[0].value
			}
		})
		fullArray = fullArray.filter(item => (item))
		let result = this.delDuplicatesFromArray(fullArray)
		result = result.map(item => item.trim())
		result.unshift('Выбрать')
		return result
	}

	filterArray(option, array, value){
		if (option !== 'Выбрать'){
			array = array.filter(item =>{
				let intArray = item.Features.filter(item => {return item.Attribute === value})
				if (intArray.length>0){
					return intArray[0].value === option
				}
			})
			array = array.filter(item => (item))
		}
		return array
	}


	filterArrayByCat(option, array){
		if (option !== 'Выбрать'){
			array = array.filter(item =>{
				let intArray = item.Features.filter(item => {return item.Attribute === CATEGORY_NAME})
				if (intArray.length>0){
					return intArray[0].value.split(' ')[0] === option
				}
			})
			array = array.filter(item => (item))
		}
		return array
	}

	// -- Служебные процедуры и функции

	// Рендер
	render() {

		let firstLableStyle = ''
		let secondLableStyle = ''
		if(this.state.tabType === 'Lan'){
			firstLableStyle = '#fff'
			secondLableStyle = '#E6EFF1'
		}else if(this.state.tabType === 'Koaks'){
			firstLableStyle = '#E6EFF1'
			secondLableStyle = '#fff'
		}

		return (
			<div className={styles.cfg}>
				{/*Белый фон и лого*/}
				<div style={{position: 'absolute', margin: '0 auto', backgroundColor: '#fff', width: '10%', height: '80px'}}/>
				<Image
					className={styles.logo}
					blockChangeScale={true}
				/>
				{/*Зеленый фон заголовка*/}
				<div style={{margin: '0 auto', backgroundColor: '#76D750', width: '100%', height: '80px'}}/>
				<div className={styles.title}>Подбор LAN-кабеля и медные компоненты</div>

				{/*Левая часть*/}
				<div style={{position: 'absolute', top: '100px', left: "20px"}}>
        	<span
						onClick={this.lanChosen}
						style={{background: firstLableStyle}}
						className={styles.cableSectionTitle + ' ' + 'activeTab'}>Подбор LAN кабелей</span>
					<span
						onClick={this.koaksChosen}
						style={{background: secondLableStyle}}
						className={styles.koaksCableTitle + ' ' + 'activeTab'}>Подбор Коаксиальных кабелей</span>
				</div>

				<div>
					{this.state.tabType === 'Lan' &&
					<div> {/*Область Подбор кабеля*/}
						{this.mainDropDown ? this.mainDropDown() : null}
						<div style={{
							position: 'absolute',
							top: '153px',
							left: '20px',
							margin: '0 auto',
							backgroundColor: '#fff',
							width: '440px',
							height: '123px',
							zIndex: '1'
						}}/>

						<div style={{
							position: 'absolute',
							top: '287px',
							left: '215px',
							zIndex: '1',
							width: '278px',
						}}>* - необходимо выбрать все фильтры для подбора дополнительных аксессуаров</div>
						<FilterRouter app={this}/>


						<button
							style={{top: '320px', left: '200px'}}
							className={styles.ResetButton}
							onClick={this.onClearFiltersClick}
						>Сбросить фильтр</button>

					</div>
					}
					{this.state.tabType === 'Koaks' &&

					<div>
						{/*Область Коаксиальный кабель*/}
						{this.koaksCableDropDown ? this.koaksCableDropDown() : null}
						<div style={{
							position: 'absolute',
							top: '153px',
							left: '20px',
							margin: '0 auto',
							backgroundColor: '#fff',
							width: '440px',
							height: '74px',
							zIndex: '1'
						}}/>
					</div>
					}
				</div>

				{/*Спецификация*/}
				<Table
					title='Аксессуары'
					type='NoBucket'
					items={this.state.itemList}
					styles={{width: '440px', height: this.state.tableHeight, top: this.state.tableTop, left: '20px', fontSize: '12px'}}
					onSelect={this.onListItemCheck}
					addBasket={this.addBasket}
					itemInfo={this.state.itemInfo}
					color='#76d750'
					configType='lan'
				/>


				{/*Середина*/}
				{/*Корзина*/}
				<Table
					title='Корзина'
					type='Bucket'
					items={this.state.specList}
					styles={{width: '440px', height: '585px', top: '100px', left: '480px', fontSize: '12px'}}
					onSelect={this.onListItemCheck}
					onDelete={this.onDelete}
					onChangeQuantity={this.onChangeQuantity}
					color='#76d750'
					configType='lan'
				/>
				<div className={styles.sum}>Сумма: {this.state.summ} руб.</div>


				{/*Правая часть*/}
				{/* Артикул и имя */}
				<div className={styles.itemInfoBG}/>
				{this.state.itemInfo && this.state.itemInfo[0] ? (
					<a href={`https://qr.iek.group/${this.state.itemInfo && this.state.itemInfo[0] && this.state.itemInfo[0].art}`}
						 target="_blank">
						<div className={styles.itemInfo}>
							<div className={styles.itemInfo_Article}>{this.state.itemInfo && this.state.itemInfo[0] && this.state.itemInfo[0].art}</div>
							<div>{this.state.itemInfo && this.state.itemInfo[0] && this.state.itemInfo[0].name}</div>
						</div>
					</a>
				) : (
					<div className={styles.itemInfoNoArticle}/>
				)}

				{/* Фото */}
				<Image
					className={styles.itemImg}
					url={this.state.itemInfo && this.state.itemInfo[0] && this.state.itemInfo[0].ImgPng[0].file_ref.uri ? this.state.itemInfo[0].ImgPng[0].file_ref.uri : null}
				/>

				{/* Описание */}
				<div style={{
					position: 'absolute',
					top: '452px',
					left: '940px',
					backgroundColor: '#fff',
					width: '434px',
					height: '292px'
				}}/>
				{this.state.itemInfo && this.state.itemInfo[0] && this.state.itemInfo[0].Description[0].desc_ru ? (
					<div className={styles.description}>
						{this.state.itemInfo[0] && this.state.itemInfo[0].Description[0].desc_ru}
					</div>
				) : (
					<div className={styles.descriptionEmpty}>
					</div>
				)}


				{/*Кнопки*/}
				{this.getCustomButtons ? this.getCustomButtons() : null}

				{/*Нижняя плашка*/}
				{/* На основной сайт IEK */}
				<div style={{position:'absolute', backgroundColor: '#ffffff', width: '50%', height: '20px', top:'820px'}}/>
				<a  className={styles.homeLink} href={'https://www.itk-group.ru/'} target="_blank">На основной сайт ITK</a>

				{/* Техническая поддержка */}
				<div style={{position:'absolute', backgroundColor: '#76D750', width: '50%', height: '20px', top:'820px', left: '700px'}}/>
				<a style={{
					position: 'absolute',
					top: '823px',
					left: '415px',
					color: '#37424a',
					width: '141px',
					height: '14px'
				}} href={'https://www.itk-group.ru/servis-i-podderzhka/'} target="_blank">Техническая поддержка:
				</a>
				<span className={styles.techSupport}>+7 (495) 542-22-24</span>

			</div>

		)
	}
}

/**
 * Фильтр дополнительных устройство для подбора
 */
class FilterRouter extends React.Component {
	render() {

		let filter = null;

		switch (this.props.app.state.filterAddDivice) {
			case 'plug':
				filter = <FilterModePlug {...this.props} />;
				break;

			case 'tool':
				filter = <FilterModeTool {...this.props} />;
				break;

			case 'module':
				filter = <FilterModeModule {...this.props} />;
				break;

			case 'patch_panel':
				filter = <FilterModePatchPanel {...this.props} />;
				break;

			case 'patch_cord':
				filter = <FilterModePatchCord {...this.props} />;
				break;
		}

		return (
			<div>

				<span className={styles.addDeviceLable}>Подобрать дополнительные аксессуары:</span>

				<select
					className={styles.addDevice}
					onChange={this.props.app.onAddDiviceChange}
					value={this.props.app.state.filterAddDivice}
					disabled={!this.props.app.state.addFilterEnabled}
				>
					<option value="Выбрать">Выбрать</option>
					<option value="plug">Разъемы</option>
					<option value="tool">Инструменты</option>
					<option value="module">Модули и розетки</option>
					<option value="patch_panel">Патч-панели</option>
					<option value="patch_cord">Патч-корды</option>
				</select>

				{filter}
			</div>
		);
	}
}

/**
 * Разъем
 */
class FilterModePlug extends React.Component {
	render() {

		return (
			<div>
				{/*Необходим специальный инструмент*/}
				<div className={styles.AddSectionTitle}>Подбор разъемов</div>
				{this.props.app.plugDropDown ? this.props.app.plugDropDown() : null}
				<div style={{position:'absolute', top:'365px', left:'20px', margin: '0 auto', backgroundColor: '#fff', width: '440px', height: '110px', zIndex:'1'}}/>
			</div>
		);
	}
}

/**
 * Инструменты
 */
class FilterModeTool extends React.Component {
	render() {

		return (
			<div>
				{/*Необходим специальный инструмент*/}
				<div className={styles.AddSectionTitle}>Подбор Инструментов</div>
				{this.props.app.getToolCheckBox ? this.props.app.getToolCheckBox() : null}
				{this.props.app.toolsDropDown ? this.props.app.toolsDropDown() : null}
				<div style={{position:'absolute', top:'365px', left:'20px', margin: '0 auto', backgroundColor: '#fff', width: '440px', height: '286px', zIndex:'1'}}/>
			</div>
		);
	}
}

/**
 * Модули
 */
class FilterModeModule extends React.Component {
	render() {

		return (
			<div>
				{/*Область модули*/}
				<div className={styles.AddSectionTitle}>Подбор Модулей</div>
				{this.props.app.moduleDropDown ? this.props.app.moduleDropDown() : null}
				<div style={{position:'absolute', top:'365px', left:'20px', margin: '0 auto', backgroundColor: '#fff', width: '440px', height: '160px', zIndex:'1'}}/>
			</div>
		);
	}
}

/**
 * Патч-панели
 */
class FilterModePatchPanel extends React.Component {
	render() {

		return (
			<div>
				{/*Область модули*/}
				<div className={styles.AddSectionTitle}>Подбор Патч-панелей</div>
				{this.props.app.patchPanelDropDown ? this.props.app.patchPanelDropDown() : null}
				<div style={{position:'absolute', top:'365px', left:'20px', margin: '0 auto', backgroundColor: '#fff', width: '440px', height: '160px', zIndex:'1'}}/>
			</div>
		);
	}
}

/**
 * Патч-корды
 */
class FilterModePatchCord extends React.Component {
	render() {

		return (
			<div>
				{/*Область модули*/}
				<div className={styles.AddSectionTitle}>Подбор Патч-кордов</div>
				{this.props.app.patchCordDropDown ? this.props.app.patchCordDropDown() : null}
				<div style={{position:'absolute', top:'365px', left:'20px', margin: '0 auto', backgroundColor: '#fff', width: '440px', height: '160px', zIndex:'1'}}/>
			</div>
		);
	}
}

class DropDown extends React.Component {

	render() {
		let typeCap = this.props.app.capitalizeFirstLetter(this.props.type)

		return <div>
			<span className={styles.selectLabel} style={{top: this.props.y + 'px', left: this.props.x + 'px'}}>{this.props.header}</span>
			<select
				className={styles.selectBase}
				style={{top: this.props.y + 17 + 'px', left: this.props.x + 'px'}}
				onChange={this.props.app['on' + typeCap + 'Change']}
				value={this.props.app.state['filter' + typeCap]}
				disabled={!(this.props.app.state[this.props.type + 'Options'].length > 1)}
			> {this.props.app.state[this.props.type + 'Options'].length > 0
				? this.props.app.state[this.props.type + 'Options'].map((option, index) => {
					return (
						<option value={option} key={index + option}>{option} </option>)
				})
				: <option value="Выбрать">Выбрать</option>
			}
			</select>
		</div>
	}

}

class CustomeCheckBox extends React.Component {

	render() {

		let typeCap = this.props.app.capitalizeFirstLetter(this.props.type)

		return <div>
			<label className={styles.modeChk}
						 style={{top: this.props.lableY + 'px', left: this.props.x + 'px', width: '120px'}}>{this.props.header}</label>
			<input
				style={{top: this.props.y + 'px', left: this.props.x + 140 + 'px', position: 'absolute', zIndex: '10'}}
				type="checkbox"
				checked={this.props.app.state[this.props.type]}
				onChange={this.props.app['on' + typeCap + 'Change']}/>
		</ div>
	}
}
export default LanConfigurator;



// WEBPACK FOOTER //
// ./src/react/LanConfigurator.jsx